<ng-container [formGroup]="form">
  <div class="group">
    <rask-selector
      aid="inputMottagningsplats"
      label="{{'KUNDORDER_DETAIL_MOTTAGNINGSPLATS' | translate}}"
      formControlName="mottagningsplats"
      [required]="true"
      class="col-lg-12"
      [ngClass]="{'low': !showLabels}"
      [reverseLookup]="false"
      [rule]="validation.mottagningsplats"
      [search]="searchForMottagningsplats"
      [viewFormatter]="mottagningsplatsViewFormatter"
      [itemDisabled]="mottagningsplatsDisabled"
      [raskDisabledControl]="readonly">
    </rask-selector>
    @if (!newMode) {
      <div
        popoverClass="svea-popover"
        placement="bottom-left"
        [autoClose]="'outside'"
        [ngbPopover]="alternativaMottagningsplatser"
        class="alternative-text">
        {{'KUNDORDER_DETAIL_ALTERNATIVA_MOTTAGNINGSPLATSER' | translate}}
        ({{mottagningsplatser.length}})
      </div>
    }
  </div>
</ng-container>

<ng-template #alternativaMottagningsplatser>
  <rask-alternativa-mottagningsplatser
    [alternativaMottagningsplatser]="mottagningsplatser"
    [search]="searchForMottagningsplats"
    (onChange)="alternativaMottagningsplatserChanged($event)"
    [mottagningsplatsViewFormatter]="mottagningsplatsViewFormatter"
    [mottagningsplatsDisabled]="mottagningsplatsDisabled"
    [readonly]="readonly">
  </rask-alternativa-mottagningsplatser>
</ng-template>